import React, { Fragment } from 'react'
import classnames from 'classnames'
import { Field } from 'formik'
import Label from './Label'
import './index.css'

const CustomField = props => {
  const { type, checked, onClick, label } = props
  return type === 'radio' ? (
    <Fragment>
      <div className="cookunity__input_radio_container">
        <div
          className={classnames('cookunity__input_radio', { checked })}
          onClick={onClick}>
          <div className="checkmark" />
        </div>
      </div>
      <Field {...props} className="cookunity__input_field" />
    </Fragment>
  ) : type === 'checkbox' ? (
    <div className="cookunity__checkbox_group">
      <div className="cookunity__input_checkbox_container">
        <div
          className={classnames('cookunity__input_checkbox', { checked })}
          onClick={onClick}
        />
      </div>
      <Field {...props} className="cookunity__input_field" />
      {label && <Label onClick={onClick}>{label}</Label>}
    </div>
  ) : (
    <Field {...props} className="cookunity__input_field" />
  )
}

export default CustomField



// WEBPACK FOOTER //
// ./src/components/Form/Field.jsx